import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0","key":"svg-0"}],["path",{"d":"M16 8a4 4 0 1 0 -8 0v8","key":"svg-1"}]]

const IconNumber6 = createReactComponent('outline', 'number-6', 'Number6', __iconNode);

export default IconNumber6;